<template>
    <div class="navigatorPage">
        <div class="navigator" v-if="isChinese">
            <div v-for="item in navList" :key="item.fItemId" :style="{ backgroundColor: item.color }" @click="toLink(item)"
                class="navigatorItem">
                <div class="title">{{ item.fChTitle }}</div>
            </div>
        </div>
        <div class="navigator" v-else>
            <div v-for="item in navList" :key="item.fItemId" :style="{ backgroundColor: item.color }"
                @click="toEnLink(item)" class="navigatorItem">
                <div class="title">{{ item.fEnTitle }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    created() {

    },
    data() {
        return {
            navList: [
                {
                    fItemId: 1,
                    src: '/static/images/MaliBao/首页/首页中文.png',
                    fLink: '/home',
                    color: '#c50000',
                    fChTitle: '首页',
                    fEnTitle: 'Home'
                },
                {
                    fItemId: 2,
                    src: '/static/images/MaliBao/首页/关于我们中文.png',
                    fLink: '/about',
                    color: '#84c126',
                    fChTitle: '关于我们',
                    fEnTitle: 'About us'
                },
                {
                    fItemId: 3,
                    src: '/static/images/MaliBao/首页/产品展示中文.png',
                    fLink: '/product?index=-1&fInterId=-1',
                    color: '#3c756a',
                    fChTitle: '产品展示',
                    fEnTitle: 'Products'
                },
                {
                    fItemId: 4,
                    src: '/static/images/MaliBao/首页/中英文切换_中文.png',
                    fLink: '/home',
                    color: '#f9c401',
                    fChTitle: '英文版/English',
                    fEnTitle: '中文版/Chinese'
                },
            ],
            isChinese: false
        }
    },

    methods: {
        toLink(item) {
            this.$router.push(item.fLink)
            if (item.fItemId == 4) {
                this.isChinese = false,
                    this.$store.state.language = 2
            }
            this.$store.state.input = ''
        },
        toEnLink(item) {
            console.log("英语item", item)
            this.$router.push(item.fLink)
            if (item.fItemId == 4) {
                this.isChinese = true,
                    this.$store.state.language = 1

            }
            this.$store.state.input = ''
        }
    }
}
</script>

<style scoped lang="less">
.navigatorPage {
    margin-bottom: .625rem;

    .navigator {
        width: 61.875rem;
        height: 3.75rem;
        margin: 0 auto;
        display: flex;

        .navigatorItem {
            cursor: pointer;
            width: 15.5rem;
            height: 3.75rem;

            .title {
                width: 100%;
                height: 100%;
                color: white;
                font-weight: bold;
                font-size: 1.125rem;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
            }

            // .title:hover {
            //     transform: translateY(-2px);
            //     transition: all 0.3s ease-in-out;
            //     font-size: 1.1875rem;
            // }

            img {
                width: 15.4688rem;
            }
        }

    }
}
</style>


// WEBPACK FOOTER //
// src/components/public/Navigator.vue